import React from 'react';
import bgIllustration from 'assets/img/spot-illustrations/transcriptionbg.png';
import bgIllustrationdark from 'assets/img/spot-illustrations/transcriptionbgdark.png';
import { useAppContext } from 'providers/AppProvider';
import { Card } from 'react-bootstrap';

export const NoTranscriptionCard = () => {
  // Obtener el contexto del tema
  const {
    config: { isDark }
  } = useAppContext();

  return (
    <Card className="mb-0 hvasystem-QA">
      <div
        className="bg-holder bg-card"
        style={{
          backgroundImage: !isDark
            ? `url(${bgIllustration})`
            : `url(${bgIllustrationdark})`,
          backgroundSize: 'auto',
          backgroundPosition: 'bottom right 4px'
        }}
      />
      <Card.Body className="z-5">
        <div className="text-start">
          <h5 className="text-body-tertiary mb-3 mt-6 w-50">
            Automatic call transcription and summary?
          </h5>
          <p className="text-body-quaternary fs-9 mb-8 w-50 w-xl-50 lh-sm">
            Improve efficiency instantly and effortlessly
            <br className="d-none d-xxl-block" /> by allowing easy & simple call
            transcription
            <br className="d-none d-xxl-block" /> and call summary using our AI
            <br className="d-none d-xxl-block" /> solution. Ask us today!
          </p>
        </div>
      </Card.Body>
    </Card>
  );
};
